import { useState } from "react";

const testimonials = [
  {
    initials: "SL",
    name: "陳書林",
    title: "採購總監 - 飛鴻果品貿易公司",
    quote:
      "與 Farmer's Basket 合作已經三年了,他們的水果品質始終如一,物流配送也非常及時。特別是火龍果和芒果,我們的客戶都非常滿意。這是一個值得長期合作的優質供應商!",
  },
  {
    initials: "CJ",
    name: "Charles Johnson",
    title: "General Manager - Fresh Harvest Supermarket",
    quote:
      "We have been partnering with Farmer's Basket for over two years. Their dragon fruits and mangoes consistently meet our high standards, and the cold-chain logistics ensure every shipment arrives fresh. A truly reliable partner for premium tropical fruits.",
  },
];

export default function AboutSection() {
  const [current, setCurrent] = useState(0);

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-6">
            <div className="inline-block px-4 py-2 bg-orange-100 text-orange-700 text-sm font-medium rounded-full">
              關於我們
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              越南優質水果
              <br />
              您的可靠
              <br />
              出口夥伴
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                Farmer's Basket 成立於2014年,是越南領先的熱帶水果出口企業。我們在湄公河三角洲擁有超過2000公頃的合作果園,專注於火龍果、芒果、榴槤等優質熱帶水果的種植與出口。
              </p>
              <p>
                我們更自設集散中心、冷藏空間，更有完善海陸空物流系統，務求令貴客享受一條龍服務，省時又省心。產品遠銷於中、日、韓、美、英及中東等多個國家和地區，深受客戶歡迎。
              </p>
            </div>
            <div className="grid grid-cols-2 gap-6 pt-4">
              <div className="space-y-2">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg">
                  <i className="ri-plant-line text-2xl text-orange-700"></i>
                </div>
                <h3 className="font-semibold text-gray-900">有機種植</h3>
                <p className="text-sm text-gray-600">採用有機種植方式,確保水果天然健康</p>
              </div>
              <div className="space-y-2">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg">
                  <i className="ri-shield-check-line text-2xl text-orange-700"></i>
                </div>
                <h3 className="font-semibold text-gray-900">品質保證</h3>
                <p className="text-sm text-gray-600">通過多項國際認證,品質值得信賴</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="bg-gradient-to-br from-orange-700 to-orange-900 rounded-3xl p-10 shadow-2xl">
              <div className="space-y-6">
                <div className="flex items-start justify-between">
                  <span className="text-sm text-orange-200">客戶評價</span>
                  <div className="flex space-x-1">
                    {testimonials.map((_, i) => (
                      <button
                        key={i}
                        onClick={() => setCurrent(i)}
                        className={`w-2 h-2 rounded-full cursor-pointer transition-colors ${
                          i === current ? "bg-white" : "bg-orange-400"
                        }`}
                      />
                    ))}
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex space-x-1 text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-xl"></i>
                    ))}
                  </div>
                  <p className="text-xl text-white leading-relaxed">
                    &ldquo;{testimonials[current].quote}&rdquo;
                  </p>
                </div>
                <div className="flex items-center justify-between pt-4">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center text-white font-semibold">
                      {testimonials[current].initials}
                    </div>
                    <div>
                      <div className="font-semibold text-white">{testimonials[current].name}</div>
                      <div className="text-sm text-orange-200">{testimonials[current].title}</div>
                    </div>
                  </div>
                  <button
                    onClick={() => setCurrent((current + 1) % testimonials.length)}
                    className="w-10 h-10 flex items-center justify-center bg-orange-600 rounded-full hover:bg-orange-500 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-line text-white"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
